import gql from 'graphql-tag';

export default gql`
  mutation createWhitelabel($whiteLabel: WhitelabelInput!) {
    createWhitelabel(whitelabel: $whiteLabel) {
      _id
    }
  }
`;
